import { Skiptrace } from 'features/Skiptrace/domain/Skiptrace.domain'
import { GET_TRACERS_QUERY } from 'features/Skiptrace/infra/remote/getTracers/getTracers.graphql'
import { mapGetTracersResponse } from 'features/Skiptrace/infra/remote/getTracers/getTracers.mapper'
import { apolloClient } from 'presentation/libs/client'

export const getTracers = async (): Promise<{ tracers: Skiptrace.Tracer[] }> =>
  await apolloClient.query({ query: GET_TRACERS_QUERY })
    .then(({ data }) => mapGetTracersResponse(data))
